var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'carousel',
    _vm.extraSettings && _vm.extraSettings.template ? `carousel-${_vm.extraSettings.template}` : null,
  ],style:({ '--cell-width': `${_vm.cellWidth}px` })},[_vm._t("default"),(!_vm.$mq.isMobile && (_vm.extraSettings ? _vm.extraSettings.template !== 'posts' : true))?_c('div',{staticClass:"navigation"},[_c('div',{staticClass:"prev",attrs:{"data-cursor":"Prev"},on:{"click":_vm.prev}}),_c('div',{staticClass:"next",attrs:{"data-cursor":"Next"},on:{"click":_vm.next}})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }